import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import UpdateSurveyApiRequest from "../request/UpdateSurveyApiRequest";

const UpdateSurveyApiService = async (request: UpdateSurveyApiRequest): Promise<boolean> => {
  const url = `/forms/${request.id}/`;
  const payload = {
    ...request,
    questions: request.questions.map(it => ({
      ...it,
      choices: Object.is(it.question_type, "mcq") ?
        it.choices.map((option, index) =>
        ({ "content": option.content, "order_number": index + 1 })) : []
    }))
  };
  const { data } = await axios.put(url, payload);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUpdateSurveyApiService = () =>
  useMutation<boolean, AxiosError, UpdateSurveyApiRequest>(
    UpdateSurveyApiService, {
      mutationKey: "UpdateSurveyApiService"
    }
  );
export default useUpdateSurveyApiService;